import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import IFrameModal from '@adsk/bim360-matrix-react-i-frame-modal';

const POPUP_VIEWER_URL = 'popupViewerUrl';
const POPUP_VIEWER_TITLE = 'popupViewerTitle';
class ControllableIFrameModal extends PureComponent {
  constructor(props) {
    super(props);

    this.routerMock = {
      push: () => {
        this.props.closeIframe();
      },
      location: {
        pathname: ''
      }
    };

    this.emptyLocationMock = {};
  }

  getLocationMock() {
    if (this.props.iframeUrl) {
      return {
        query: {
          [POPUP_VIEWER_URL]: this.props.iframeUrl,
          [POPUP_VIEWER_TITLE]: this.props.iframeTitle
        }
      };
    }
    return this.emptyLocationMock;
  }

  render() {
    return (
      <IFrameModal
        router={this.routerMock}
        location={this.getLocationMock()}
        iframeSourceUrlParameter={POPUP_VIEWER_URL}
        iframeTitleUrlParameter={POPUP_VIEWER_TITLE}
      />
    );
  }
}

ControllableIFrameModal.displayName = 'ControllableIFrameModal';

ControllableIFrameModal.propTypes = {
  closeIframe: PropTypes.func.isRequired,
  iframeUrl: PropTypes.string,
  iframeTitle: PropTypes.string
};

export default ControllableIFrameModal;
